__webpack_require__.p = "/my-3d-model/";